// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eab0352a","455":"81537c42","977":"a5c2f382"}[chunkId] + ".chunk.js";
};